export const routing = {
	login: 'login',
	recovery: 'login/recovery',
	reset: 'login/reset',
	users: 'users',
	roles: 'roles',
	media: 'image-upload',
	pages: 'pages',
	gallery_groups: 'gallery-groups',
	galleries: 'galleries',
	gallery_images: 'gallery-images',
	link_types: 'link-types',
	products: 'products',
	designers: 'designers',
	discount_types: 'discount-types',
	inventory: 'inventory',
	attributes: 'attributes',
	attribute_types: 'attribute-types',
	product_categories: 'product-categories',
	product_images: 'product-images',
	discount_cupons: 'discount-cupons',
	discount_status: 'discount-status',
	discount_types: 'discount-types',
	discount_usages: 'discount-usages',
	shopping_carts: 'shopping-cart',
	orders: 'orders',
	free_shipping: 'free-shipping',
	countries: 'countries',
	mexico_states: 'mexico-states',
	brands: 'designers'
}



// WEBPACK FOOTER //
// ./src/core/config/routing.js